import { Box, CssBaseline, ThemeProvider } from '@mui/material';
import { GoogleAuth } from '@everfit-io/google-auth';
import '@everfit-io/google-auth/dist/style.css';
import { SnackbarProvider } from 'notistack';
import { useState } from 'react';

import { WorkPlanProvider } from './context/WorkPlanContext';
import { ProjectsProvider } from './context/ProjectContext';
import { TeamProvider } from './context/TeamContext';
import { MemberProvider } from './context/MemberContext';
import { EventProvider } from './context/EventContext';
import { WorkLogProvider } from './context/WorkLogContext';
import { SidebarProvider } from './context/SidebarContext';
import AppRoutes from './RootRoutes';
import { ColorModeContext, useMode } from './theme';

import { handleLogin } from './utils/common';
import { getAccessToken } from './utils/helper';

const App = () => {
  const [theme, colorMode] = useMode();
  const [isLogged, setIsLogged] = useState(() => !!getAccessToken());

  const handleAuthSuccess = (res) => {
    handleLogin(res, (val) => setIsLogged(val));
  };

  return (
    <ColorModeContext.Provider value={colorMode}>
      <GoogleAuth
        requiredAuth={!isLogged}
        clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}
        onAuthSuccess={handleAuthSuccess}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <SnackbarProvider
            maxSnack={3}
            autoHideDuration={3000}
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
            <TeamProvider>
              <MemberProvider>
                <WorkPlanProvider>
                  <WorkLogProvider>
                    <SidebarProvider>
                      <ProjectsProvider>
                        <EventProvider>
                          <Box width="100%" height="100%">
                            <AppRoutes isLogged={isLogged} />
                          </Box>
                        </EventProvider>
                      </ProjectsProvider>
                    </SidebarProvider>
                  </WorkLogProvider>
                </WorkPlanProvider>
              </MemberProvider>
            </TeamProvider>
          </SnackbarProvider>
        </ThemeProvider>
      </GoogleAuth>
    </ColorModeContext.Provider>
  );
};

export default App;
